import ModelFactory from '../model-factory';
import { BaseModel } from '../models';

const NOTIFICATION_TYPE_ICONS = {
  email: 'icon-ayudadigital-arroba',
  push: 'icon-ayudadigital-appmovil',
  firebase: 'icon-ayudadigital-appmovil',
  sms: 'icon-ayudadigital-appmovil',
  generic: 'icon-ayudadigital-appmovil',
  whatsapp: 'icon-ayudadigital-whatsapp',
};
const NOTIFICATION_SMS = 'sms';

export default class Notification extends BaseModel {
  constructor(data = {}) {
    super({
      '@id': data.id,
    });

    const typeNotification = data.modo;
    if (typeNotification !== NOTIFICATION_SMS) {
      this.subject = data.asunto || null;
    } else {
      this.subject = data.texto || null;
    }

    this.subject = data.asunto || null;
    this.from = data.de || null;
    this.type = data.modo || null;
    this.text = data.texto || null;
    this.bussinessType = data.tipoNegocio.id;

    if ((data.texto === null || data.texto === '') && data.html !== '') {
      this.text = data.html;
    }

    if (data.fechas != null) {
      this.creationDate = data.fechas.creacion || null;
    }
  }

  get icon() {
    return NOTIFICATION_TYPE_ICONS[this.type] || null;
  }
}

export const modelFactory = new ModelFactory('cges/notifications', (data) => new Notification(data));
